import React from 'react';
import AdminUserDonations from '../components/Admin/AdminUserDonations';

export default function AdminUserDonationsPage() {
  return <AdminUserDonations />;
}
